import { Model } from 'modules/core/lib/mobx-rest'

interface IGDPRDataRetention {
  id: number
  company_id: number
  ats_company_id: number
  consent_limit_enabled: boolean
  default_retention_limit: number
  talent_pool_retention_limit: number
  notify_expired_permissions: boolean
  erase_rejected_candidates: boolean
  auto_deletion_enabled: boolean
  grace_period_before_deletion: number
  consent_renewal_email_enabled: boolean
  consent_renewal_email_subject: string
  consent_renewal_email_body: string
}

class GDPRDataRetention extends Model<IGDPRDataRetention> {
  static urlRoot() {
    return '/ats/data_retention_configurations'
  }
}

export default GDPRDataRetention
